import React, { useEffect, useState } from "react";
import DataTable from "../../Components/DataTable";
import Input, { Label } from "../../Components/Input";
import useFetchData from "../../Hooks/useFetchData";
import useInput from "../../Hooks/useInput";
import Modal from "react-awesome-modal";
import useSave from "../../Hooks/useSave";
import useDeleteData from "../../Hooks/useDeleteData";


const Categories = () => {
    const [Editing, setEditing] = useState(false);
    const initialState = {
        code: "",
        name: ""
    };
    const url = "api/UCCategory/";
    const { response, error, isLoading } = useFetchData(url);

    const { HandleDelete, HandleEditData } = useDeleteData(url);
    const { values, HandleChange, reset, FillData } = useInput(initialState);
    const [openModel, setOpenModel] = useState(false);

    let TableHeader = ["Code", "Name"];
    let rowData = ["code", "name"];

    const handleEdit = k => {
        const data = {
            id: k.id,
            code: k.code,
            name: k.name
        };
        FillData(data);
        setEditing(true);
    };
    const handleDelete = k => {
        HandleDelete(k.id);
        response.splice(response.indexOf(k), 1);
    };
    const HandleSubmit = e => {
        e.preventDefault();
        handleModel(false)
        useSave(url, values);
        reset();
        response.push(values)
    };
    const HandleUpdate = e => {
        e.preventDefault();
        handleModel(false)
        HandleEditData(values);
        reset();
        response.splice(response.indexOf(values), 1, values);
    };
    const HandleOnClose = e => {
        e.preventDefault();
        setEditing(false);
        handleModel(false);
        reset();
    };
    const handleModel = (e) => {
        setOpenModel(e);
    }
    const handleResetModel = () => {
        setEditing(false);
        reset();
    }
    return (
        <div>
            {isLoading ? (
                <p>Loading</p>
            ) : (
                    <DataTable
                        page={"UD Category"}
                        data={response}
                        HandleOnClose={HandleOnClose}
                        handleEdit={e => handleEdit(e)}
                        handleDelete={e => handleDelete(e)}
                        rowData={rowData}
                        TableHeader={TableHeader}
                        handleModel={(e) => handleModel(e)}
                        handleResetModel={handleResetModel}
                    >
                        <CategoryForm
                            values={values}
                            IsEditing={Editing}
                            HandleUpdate={HandleUpdate}
                            HandleOnClose={HandleOnClose}
                            HandleSubmit={HandleSubmit}
                            HandleChange={HandleChange}
                            openModel={openModel}
                            handleModel={(e) => handleModel(e)}
                        />
                    </DataTable>
                )}
        </div>
    );
};

export default Categories;

const CategoryForm = props => {
    return (
        <Modal visible={props.openModel} width="40%" height="35%" effect="fadeInUp">
            <div className="modal-header">
                <h4 className="modal-title">Add User Category</h4>
                <button
                    onClick={() => props.handleModel(false)}
                    type="button"
                    className="close"
                    data-dismiss="modal"
                    aria-hidden="true"
                >
                    ×
                    </button>
            </div>
            <div className="modal-body">
                <div className="row">
                    <div className="col-md-10 md-offset-2">
                        <div className="form-group row m-b-10">
                            <Label label="Code" isRequired={true} />
                            <div className="col-md-6">
                                <Input
                                    name="code"
                                    value={props.values.code}
                                    HandleChange={props.HandleChange}
                                />
                            </div>
                        </div>
                        <div className="form-group row m-b-10">
                            <Label label="Name" isRequired={true} />
                            <div className="col-md-6">
                                <Input
                                    name="name"
                                    value={props.values.name}
                                    HandleChange={props.HandleChange}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="modal-footer">
                <a
                    className="btn btn-white"
                    data-dismiss="modal"
                    onClick={props.HandleOnClose}
                >
                    Close
        </a>
                {props.IsEditing ? (
                    <button
                        type="submit"
                        onClick={props.HandleUpdate}
                        className="btn btn-primary"
                    >
                        Update
                    </button>
                ) : (
                        <button
                            type="submit"
                            onClick={props.HandleSubmit}
                            className="btn btn-primary"
                        >
                            Save
                        </button>
                    )}
            </div>
        </Modal>

    );
};
